module.exports = __webpack_public_path__ + "static/img/woman_glove_5.cf7c29d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/woman_glove_5.png
// module id = jalP
// module chunks = 0